var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnMarkedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.6C0 0.72 0.72 0 1.6 0H11.2C11.6243 0 12.0313 0.168571 12.3314 0.468629C12.6314 0.768687 12.8 1.17565 12.8 1.6V16L6.4 12.8L0 16V1.6ZM1.6 1.6V13.6L6.4 11.2L11.2 13.6V1.6H1.6ZM5.6 5.6V4H7.2V5.6H8.8V7.2H7.2V8.8H5.6V7.2H4V5.6H5.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnMarkedIcon);
export default __webpack_public_path__ + "static/media/unMarkedIcon.de47de7d7552404a8ee07b7f6b57b33a.svg";
export { ForwardRef as ReactComponent };